import React, { useState } from 'react';
import ResizableDraggableCard from './ResizableDraggableCard';
import RegistersTableWidget from '../features/processes/components/widgets/RegistersTable/RegistersTable';
import HorizontalBarChartWidget from '../features/processes/components/widgets/HorizontalBarChart/HorizontalBarChartWidget';
import PieChartWidget from '../features/processes/components/widgets/PieChart/PieChartWidget';
import { useWidgets } from '../providers/WidgetContext';
import TimeRateChartWidget from '../features/processes/components/widgets/TimeRateChart/TimeRateChartWidget';
import MetricWidget from '../features/processes/components/widgets/Metric/MetricWidget';
import MultiMetricWidget from '../features/processes/components/widgets/MultiMetric/MultiMetricWidget';
import RegistersTableForm from '../features/processes/components/widgets/RegistersTable/RegistersTableForm';
import HorizontalBarChartForm from '../features/processes/components/widgets/HorizontalBarChart/HorizontalBarChartForm';
import PieChartForm from '../features/processes/components/widgets/PieChart/PieChartForm';
import MetricForm from '../features/processes/components/widgets/Metric/MetricForm';
import MultiMetricForm from '../features/processes/components/widgets/MultiMetric/MultiMetricForm';
import TimeRateChartForm from '../features/processes/components/widgets/TimeRateChart/TimeRateChartForm';
import StatusRegisterForm from '../features/processes/components/widgets/StatusRegister/StatusRegisterForm';

import Modal from './Modal';
import { useDashboards } from '../providers/DashboardContext';
import TelemetryLineChartWidget from '../features/dashboards/widgets/TelemetryLineChart/TelemetryLineChartWidget';
import TelemetryLineChartForm from '../features/dashboards/widgets/TelemetryLineChart/TelemetryLineChartForm';
import PorcentualRateChartForm from '../features/processes/components/widgets/PorcentualRateChart/PorcentualRateChartForm';
import PorcentualRateChartWidget from '../features/processes/components/widgets/PorcentualRateChart/PorcentualRateChartWidget';
import OEEChartWidget from '../features/processes/components/widgets/OEE/OEEChartWidget';
import OEEForm from '../features/processes/components/widgets/OEE/OEEForm';
import StatusRegisterWidget from '../features/processes/components/widgets/StatusRegister/StatusRegisterWidget';
import PlanningTableForm from '../features/processes/components/widgets/PlanningTable/PlanningTableForm';
import PlanningTable from '../features/processes/components/widgets/PlanningTable/PlanningTable';

const DashboardSpace = () => {
  
  const {
    loadingWidgets,
    containerRef,
    cards,
    handleDrag, 
    handleResize, 
    duplicateCard, 
    deleteCard,updateCard} = useWidgets();
    
    const [showEditForm, setShowEditForm] = useState(false);
    const [widgetToEdit, setWidgetToEdit] = useState()
    const {selectedTab, dashboard} = useDashboards(); 

    console.log(cards,selectedTab)
    const handleEdit = (id, type, title) => {
      setShowEditForm(true);
      setWidgetToEdit({id,type, title})
    }
    const toggleEditWidgetModal = () => {
      setShowEditForm(false);
    }
  return (
    <div
      ref={containerRef}
      className="relative w-full h-screen bg-gray-100 overflow-auto p-4"
    >
      <Modal
        isOpen={showEditForm}
        onClose={() => {
          setShowEditForm(false);
          setWidgetToEdit({})
        }}
        title={"Editar - " + widgetToEdit?.title}
        customType={2}
        colorTitle="bg-bluesens"
        size="w-2/4"
      >
        { widgetToEdit && (
          <>
            {/* Telemetria */}
            {widgetToEdit.type === "telemetryLineGraph" && <TelemetryLineChartForm onSubmit={toggleEditWidgetModal} id={widgetToEdit.id}/>}
            {/* procesos */}
            {widgetToEdit.type === "processTable" && <RegistersTableForm onSubmit={toggleEditWidgetModal} id={widgetToEdit.id}/>}
            {widgetToEdit.type === "processHorizontalBarChart" && <HorizontalBarChartForm onSubmit={toggleEditWidgetModal} id={widgetToEdit.id}/>}
            {widgetToEdit.type === "processPieChart" && <PieChartForm onSubmit={toggleEditWidgetModal} id={widgetToEdit.id}/>}
            {widgetToEdit.type === "processMetric" && <MetricForm onSubmit={toggleEditWidgetModal} id={widgetToEdit.id}/>}
            {widgetToEdit.type === "processMultiMetric" && <MultiMetricForm onSubmit={toggleEditWidgetModal} id={widgetToEdit.id}/>}
            {widgetToEdit.type === "processTimeRate" && <TimeRateChartForm onSubmit={toggleEditWidgetModal} id={widgetToEdit.id}/>}
            {widgetToEdit.type === "processPorcentualTimeRate" && <PorcentualRateChartForm onSubmit={toggleEditWidgetModal} id={widgetToEdit.id}/>}
            {widgetToEdit.type === "processOEE" && <OEEForm onSubmit={toggleEditWidgetModal} id={widgetToEdit.id}/>}
            {widgetToEdit.type === "processStatusRegister" && <StatusRegisterForm onSubmit={toggleEditWidgetModal} id={widgetToEdit.id}/>}
            {widgetToEdit.type === "processPlanning" && <PlanningTableForm onSubmit={toggleEditWidgetModal} id={widgetToEdit.id}/>}
            
          </>
          
        )}
      </Modal>
      {dashboard && !loadingWidgets && (
        <>
          {cards.map(card => (
            <ResizableDraggableCard
              key={card.id}
              id={card.id}
              x={card.x}
              y={card.y}
              type={card.type}
              width={card.width}
              height={card.height}
              title={card.title}
              containerWidth={containerRef.current?.offsetWidth || 0}
              containerHeight={containerRef.current?.offsetHeight || 0}
              onDrag={handleDrag}
              onResize={handleResize}
              onDuplicate={duplicateCard}
              onDelete={deleteCard}
              onUpdate={updateCard}
              onEdit={handleEdit}
            >
              {card.type === "processTable"&& (
                <RegistersTableWidget id={card.id}/>
              )}
              {card.type === "processHorizontalBarChart" && (
                <HorizontalBarChartWidget id={card.id}/>
              )}
              {card.type === "processPieChart" && (
                <PieChartWidget id={card.id}/>
              )}
              {card.type === "processTimeRate" && (
                <TimeRateChartWidget id={card.id}/>
              )}
              {card.type === "processPorcentualTimeRate" && (
                <PorcentualRateChartWidget id={card.id}/>
              )}
              {card.type === "processMetric" && (
                <MetricWidget id={card.id}/>
              )}
              {card.type === "processMultiMetric" && (
                <MultiMetricWidget id={card.id}/>
              )}
              {card.type === "processOEE"&& (
                <OEEChartWidget id={card.id}/>
              )}
              {card.type === "processStatusRegister" && (
                <StatusRegisterWidget id={card.id}/>
              )}
              {card.type === "processPlanning" && (
                <PlanningTable id={card.id}/>
              )}
              {card.type === "telemetryLineGraph" && (
                <TelemetryLineChartWidget id={card.id}/>
              )}

            </ResizableDraggableCard>
          ))}
        </>
      )}
      
      
    </div>
  );
};

export default DashboardSpace;
